import { ErrorCodes } from '../../app/constants/Server/ErrorCodes'

export const isResultError = (result: { payload?: any; error?: any }) => {
  return result.error ? true : false
}

export const getErrorCodeFromResult = (result: {
  payload?: any
  error?: any
}) => {
  if (result && isResultError(result)) {
    if (result.payload) {
      return result.payload.error.code
    }
    return null
  }
}

export const getErrorMessageFromResult = (result: {
  payload: any
  error?: any
}) => {
  if (isResultError(result)) {
    //check if we have payload
    if (result.payload) {
      switch (result.payload.error.code) {
        case ErrorCodes.AUTHENTICATION:
        case ErrorCodes.AUTHORIZATION:
        case ErrorCodes.NOT_FOUND:
        case ErrorCodes.UNHANDLED_EXCEPTION:
        case ErrorCodes.SERVICE_UNAVAILABLE: {
          return result.payload.error.message
        }
        case ErrorCodes.VALIDATION: {
          return result.payload.error.validationErrors[0].message
        }
        default: {
          return null
        }
      }
    }
    return null
  }
}
